import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const VISIT_LABEL: Record<string, string> = { home: "Home visit", workplace: "Workplace visit", surprise: "Surprise proposal", virtual: "Virtual appointment", events: "Event & gifting" };

export function Quotes({ b }: any) {
  const [live, setLive] = useState<any[]>([]);
  useEffect(() => { if (b.include_approved) api.get("/client-quotes/approved", { params: b.visit_type ? { visit: b.visit_type } : {} }).then((r) => setLive(r.data)).catch(() => {}); }, [b.include_approved, b.visit_type]);
  const own = (b.items || []).filter((q: any) => !b.visit_type || !q.visit || q.visit === b.visit_type);
  const items = [...own, ...live].filter((q: any) => q.quote).slice(0, 9);
  if (!items.length) return null;
  return (
    <section className="max-w-[1200px] mx-auto px-5 md:px-12 py-16 md:py-24 text-center" data-testid="quotes-block">
      {b.heading && <h2 className="font-display uppercase tracking-[0.08em] text-2xl md:text-3xl">{b.heading}</h2>}
      <div className={`mt-12 grid gap-10 md:gap-14 ${items.length === 2 ? "md:grid-cols-2 max-w-4xl mx-auto" : items.length > 2 ? "md:grid-cols-3" : ""}`}>
        {items.map((q: any, i: number) => {
          const visit = VISIT_LABEL[q.visit || q.visit_type];
          return (
            <figure key={i} className="rise" style={{ animationDelay: `${(i % 3) * 120}ms` }} data-testid={`quote-${i}`}>
              <span className="block font-display text-5xl leading-none text-[var(--c-primary)]" aria-hidden="true">“</span>
              <blockquote className="mt-2 font-display text-xl md:text-2xl font-light italic leading-snug">{q.quote}</blockquote>
              {(q.name || q.place) && <figcaption className="mt-5 eyebrow text-neutral-600">{[q.name, q.place].filter(Boolean).join(", ")}</figcaption>}
              {visit && <p className="mt-1.5 text-[10px] uppercase tracking-[0.2em] text-[var(--c-primary)]" data-testid={`quote-visit-${i}`}>{visit}</p>}
            </figure>
          );
        })}
      </div>
    </section>
  );
}
